// @flow
import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Box from "@material-ui/core/Box";
import Alert from './Alert';
import type { Props as AlertProps } from './Alert';

const useStyles = makeStyles(theme => ({
    empty: {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.text.hint,
        textAlign: 'center'
    }
}));

type Props = $ReadOnly<{
    list: $ReadOnlyArray<string>,
    alertData: $ReadOnly<{[alertId: string]: $PropertyType<AlertProps, 'alert'>}>,
    emptyMessage?: Node
}>;

function AlertList({ list, alertData, emptyMessage }: Props) {
    const classes = useStyles();

    if(list.length === 0) {
        return (
            <Box my={2} p={2} className={classes.empty}>
                {emptyMessage || (
                    <FormattedMessage
                        id="alerts.noAlerts"
                        defaultMessage="No alerts"
                    />
                )}
            </Box>
        );
    }

    return (
        <div>
            {list.map(id => <Alert key={id} alert={alertData[id]} />)}
        </div>
    );
}

export default React.memo(AlertList);